(function($) {

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
        }
        return "";
    }

    var cookie = getCookie('collection');
    var newCookie = $('p#collection-title').text();
    var cookieValue = $('p#collection-url').text();

    var now = new Date();
    var time = now.getTime();
    time += 3600 * 2000;
    now.setTime(time);

    if ( cookieValue.includes("collection") || window.location.href.indexOf("products") > -1 || window.location.href.indexOf("the-bazaar") > -1 ) {
        if( newCookie ) {

            if(cookie) {
                if( cookie === newCookie ) {} else {
                    document.cookie = "collection=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                    document.cookie = "collection=" + cookieValue + "; expires=" + now.toUTCString() + "; path=/;";
                    // Collection Name
                    document.cookie = "collectionTitle=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                    document.cookie = "collectionTitle=" + newCookie + "; expires=" + now.toUTCString() + "; path=/;";
                }
            } else {
                document.cookie = "collection=" + cookieValue  + "; expires=" + now.toUTCString() + "; path=/;";
                document.cookie = "collectionTitle=" + newCookie  + "; expires=" + now.toUTCString() + "; path=/;";
            }
        }
    } else {
        document.cookie = "collection=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        document.cookie = "collectionTitle=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
            c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    var collectionURL = getCookie('collection');
    var collectionTitle = getCookie('collectionTitle');

    if(collectionTitle != 'All Products') {
        $('.breadcrumbs__item.allBreadcrumb').show();
    } else {
        $('.breadcrumbs__item.allBreadcrumb').hide();
    }

    if( collectionURL && collectionTitle ) {
        $('a.breadcrumbs__link.collectionBreadcrumb').attr('href', collectionURL);
        $('a.breadcrumbs__link.collectionBreadcrumb').text(collectionTitle);
    } else {
        $('.breadcrumbs__item.collectionBreadcrumbOuter').hide();
    }

    // Clear the cookies on the search page
    if (window.location.href.indexOf("search-results") > -1) {
        document.cookie = "collection=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        document.cookie = "collectionTitle=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }

})(jQuery);
